import React from "react";
import InformationPill from "~/applications/OfferSearch/Ui/OfferDetails/InformationPill";
import { Surface } from "~/guidelines/Icon";
import ListItemWithIcon from "~/guidelines/ListItemWithIcon";

export type SurfaceAmenityProps = {
  variant?: "list-item" | "pill";
  surfaceMin: number;
  surfaceMax: number;
};

const SurfaceAmenity = ({
  variant = "list-item",
  surfaceMin,
  surfaceMax,
}: SurfaceAmenityProps) => {
  const textChildren =
    surfaceMin === surfaceMax
      ? `${surfaceMax} m²`
      : `${surfaceMin} - ${surfaceMax} m²`;

  if (variant === "pill") {
    return <InformationPill icon={<Surface />} text={textChildren} />;
  }

  return <ListItemWithIcon icon={<Surface />}>{textChildren}</ListItemWithIcon>;
};

export default SurfaceAmenity;
